import { render, staticRenderFns } from "./recordtime.vue?vue&type=template&id=99229916&scoped=true"
import script from "./recordtime.vue?vue&type=script&lang=js"
export * from "./recordtime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99229916",
  null
  
)

export default component.exports